import { render, staticRenderFns } from "./EcommerceSharingDocuments.vue?vue&type=template&id=985a9d86&"
import script from "./EcommerceSharingDocuments.vue?vue&type=script&lang=js&"
export * from "./EcommerceSharingDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports